
import { Vue, Component, Prop } from 'vue-property-decorator'
import { namespace, State, Getter } from 'vuex-class'
import type { Post, Id, ReactionType, WallReactionData } from 'types'
import { Reaction } from '@padlet/arvo'
import SurfacePostReactionLikeNew from 'vuecomponents/surface-post-reaction-like-new.vue'
import SurfacePostReactionVoteNew from 'vuecomponents/surface-post-reaction-vote-new.vue'
import SurfacePostReactionStarNew from 'vuecomponents/surface-post-reaction-star-new.vue'
import SurfacePostReactionGradeNew from 'vuecomponents/surface-post-reaction-grade-new.vue'

const reaction = namespace('reaction')
const browser = namespace('browser')

@Component({
  components: {
    SurfacePostReactionLikeNew,
    SurfacePostReactionVoteNew,
    SurfacePostReactionStarNew,
    SurfacePostReactionGradeNew,
  },
})
export default class SurfacePostReactionNew extends Vue {
  @Prop() post!: Post
  @Prop() isReacting!: boolean
  @Prop() currentUserId!: Id
  @Prop() reactionData!: WallReactionData
  @Prop() reactionIds!: string[]
  @Prop() colorScheme!: 'light' | 'dark'
  @Prop({ default: 'postView' }) usageContext!: 'postView' | 'postExpandedView'

  @Getter('isReactable') canReact!: boolean

  @reaction.Getter getReactionById!: (id) => Reaction | undefined
  @reaction.Getter maxGrade!: number

  @reaction.Action createReaction!: (payload: { postId: Id; value }) => void
  @reaction.Action deleteReaction!: (payload: { postId: Id }) => void
  @reaction.Action startEditingReaction!: (payload: {
    postId: Id
    left?: number | null
    top?: number | null
    dropdownLeft?: number
    dropdownTop?: number
  }) => void

  get reactionType(): ReactionType {
    return this.reactionData.type
  }

  @reaction.State('reactionEntities') wallReactions

  get myReactionId(): string | undefined {
    return this.reactionIds.filter(
      (reactionId) => Number((this.getReactionById(reactionId) as Reaction).user_id) === Number(this.currentUserId),
    )[0]
  }

  get currentUserReacted(): boolean {
    return !!this.myReactionId
  }

  get isPadletColorSchemeDark(): boolean {
    return this.colorScheme === 'dark'
  }

  get reactionCount(): number {
    return this.reactionIds.length
  }

  create(value): void {
    if (this.$el.closest('.surface-post')?.classList.contains('noclick')) {
      // Prevent reaction event when the post is being dragged
      return
    }
    this.createReaction({ postId: this.post.id as number, value })
  }

  deleteExisting(): void {
    if (this.$el.closest('.surface-post')?.classList.contains('noclick')) {
      // Prevent reaction event when the post is being dragged
      return
    }
    this.deleteReaction({ postId: this.post.id as number })
  }

  edit(): void {
    this.$emit('edit')
  }
}
